/* eslint-disable @typescript-eslint/no-non-null-assertion */
import type { SyntheticEvent } from 'react';
import React from 'react';
import { useI18n } from '@whizz/react-i18n';
import type { AxiosError } from 'axios';
import { Button } from '../../../../../../components';
import { GLOBAL_ICONS, QUERIES_IDS } from '../../../../../../util/vars';
import type { ToggleModalProps } from '../../../../../../components/modal/types';
import { useMutation, useQueryClient } from 'react-query';
import { repository } from '@whizz/api-client';
import Loader from '../../../../../../components/loader/Loader';
import type { Tag as TagType } from '@whizz/api-model';
import { CancelButtonModal } from '../../../../../../global';
import { ModalFooter } from '../../../../../../components/modal/Modal';

const DeleteTagModal = ({ data, toggle, onSuccess, onError }: ModalProps): JSX.Element => {
  const { translate } = useI18n();
  const queryClient = useQueryClient();

  const mutationDelete = useMutation(
    repository.TagsRepository.deleteTag,
    {
      onSuccess: () => {
        queryClient.invalidateQueries([ QUERIES_IDS.ROSTER_MANAGEMENT.TAGS ]);
        queryClient.invalidateQueries([ QUERIES_IDS.ROSTER_MANAGEMENT.STUDENTS ]);
        onSuccess?.();
        toggle(false);
      },
      onError: (error: AxiosError<{ error: string }>) => {
        if (null == error.response) {
          return;
        }
        onError?.();
      },
    },
  );

  const handleSubmit = (event: SyntheticEvent) => {
    event.preventDefault();

    mutationDelete.mutate(data!.id);
  };

  return (
    <form onSubmit={handleSubmit}>
      <div className={'container space-y-6'}>
        <p>{translate('pages.ROSTER_MANAGEMENT.TAGS.DELETE_MODAL.CONTENT.LINE_1', { description: data!.description })}</p>
        <p>{translate('pages.ROSTER_MANAGEMENT.TAGS.DELETE_MODAL.CONTENT.LINE_2')}</p>
        <p>{translate('pages.ROSTER_MANAGEMENT.TAGS.DELETE_MODAL.CONTENT.LINE_3')}</p>
      </div>
      <ModalFooter>
        <CancelButtonModal
          align={'start'}
          onClick={() => toggle(false)}
          disabled={mutationDelete.isLoading}
        >
          {translate('pages.ROSTER_MANAGEMENT.TAGS.DELETE_MODAL.BUTTONS.DISCARD')}
        </CancelButtonModal>
        <Button
          type={'submit'}
          icon={GLOBAL_ICONS.delete}
          color={'negative'}
          isOutline
          disabled={mutationDelete.isLoading}
        >
          {!mutationDelete.isLoading
            ? translate('pages.ROSTER_MANAGEMENT.TAGS.DELETE_MODAL.BUTTONS.CONFIRM')
            : (<Loader disableLabel smallSize />)
          }
        </Button>
      </ModalFooter>
    </form>
  );
};

export default DeleteTagModal;


export interface ModalProps extends Pick<ToggleModalProps, 'toggle'> {
  data?: TagType;
  onSuccess?: () => void;
  onError?: () => void;
}
